import React from 'react';
import PropTypes from 'prop-types';
import { Provider as ReduxProvider } from 'react-redux';
import { HelpLinksProvider } from 'Application/HelpLinks/HelpLinksProvider';
import ReactQueryProviders from 'Application/ApplicationShell/ReactQueryProviders';
import ErrorBoundary from 'components/ErrorBoundary';
import { SparkConfigProvider } from 'xm-spark';
import { GoogleMapsProvider } from 'hooks/useGoogleMapsApi';
import withIntl from 'hoc/withIntl';

function AppWrapper({ children, globalStore, sparkConfig }) {
  return (
    <ErrorBoundary>
      <ReduxProvider store={globalStore}>
        <ReactQueryProviders>
          <GoogleMapsProvider>
            <HelpLinksProvider>
              <SparkConfigProvider sparkConfig={sparkConfig}>
                {children}
              </SparkConfigProvider>
            </HelpLinksProvider>
          </GoogleMapsProvider>
        </ReactQueryProviders>
      </ReduxProvider>
    </ErrorBoundary>
  );
}

AppWrapper.displayName = 'AppWrapper';
AppWrapper.propTypes = {
  sparkConfig: PropTypes.shape({}),
  globalStore: PropTypes.shape({}).isRequired,
  children: PropTypes.node,
};
AppWrapper.defaultProps = {
  sparkConfig: undefined,
};

export default withIntl(AppWrapper);
